import Login from '../pages/login';
import { Navigate } from 'react-router-dom';

// routes
const AuthRoutes = [
  {
    path: '/',
    element: <Navigate to="/cms/quan-ly-hoc-vien" replace />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '*',
    element: <Login />,
  },
];

export default AuthRoutes;
